import { create } from "zustand";

export type ThemeMode = "light" | "dark";
/** ТЗ 1.2 раздел 4.2: «large» — 18 px text and 44 px controls for the working forms; «default» keeps the sizes as they were. */
export type Density = "default" | "large";

interface UiState {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
  density: Density;
  setDensity: (density: Density) => void;
}

function initial(): ThemeMode {
  try {
    const stored = localStorage.getItem("wms-theme");
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    /* private mode */
  }
  return "light";
}

function initialDensity(): Density {
  try {
    return localStorage.getItem("wms-density") === "large" ? "large" : "default";
  } catch {
    return "default";
  }
}

/** Theme and density are per-device conveniences: kept in localStorage and mirrored into the profile preferences. */
export const useUiStore = create<UiState>()((set) => ({
  theme: initial(),
  setTheme(theme) {
    try {
      localStorage.setItem("wms-theme", theme);
    } catch {
      /* ignore */
    }
    set({ theme });
  },
  density: initialDensity(),
  setDensity(density) {
    try {
      localStorage.setItem("wms-density", density);
    } catch {
      /* ignore */
    }
    set({ density });
  },
}));
